import { atom, useAtom } from 'jotai'
import {
  AnalyticsEventFromNamespace,
  AnalyticsNamespace,
} from '~/types/Analytics'
import { Analytics } from '~/utils/analytics'

const analyticsMapSource = new Map<
  AnalyticsNamespace,
  Analytics<AnalyticsNamespace>
>()
const analyticsAtom = atom(analyticsMapSource)

export const useAnalytics = <TNamespace extends AnalyticsNamespace>(
  namespace: TNamespace,
) => {
  const [analyticsMap, setAnalyticsMap] = useAtom(analyticsAtom)

  const track = (
    name: AnalyticsEventFromNamespace<TNamespace>,
    data?: Record<string, unknown>,
  ) => {
    let analytics = analyticsMap.get(namespace) as
      | Analytics<TNamespace>
      | undefined
    if (!analytics) {
      analytics = new Analytics(namespace)
      analyticsMap.set(
        namespace,
        analytics as unknown as Analytics<AnalyticsNamespace>,
      )
      setAnalyticsMap(analyticsMap)
    }

    analytics.track(name, data)
  }

  return { track }
}
